import {useMemo, useSyncExternalStore} from "react";
import {useApi} from "../mate/mate-utils";
import {RequestStore} from "../RequestStore";
import type {api} from "../api";

type Mutate = typeof api.mutate;

function useMutation<Ns extends keyof Mutate, A extends keyof Mutate[Ns] & string>(
  namespace: Ns,
  action: A
): readonly [Mutate[Ns][A], boolean] {
  const api = useApi();
  const store = useMemo(() => {
    const mutation = api.mutate[namespace]?.[action] as
      | ((args?: unknown, support?: unknown) => Promise<unknown>)
      | undefined;
    if (!mutation) throw new Error(`No mutation found for '${namespace}.${action || ""}'`);
    return new RequestStore(mutation);
  }, [api, namespace, action]);
  const {state} = useSyncExternalStore(store.subscribe, store.getSnapshot);
  return [store.call as Mutate[Ns][A], state === "pending"];
}

export default useMutation;
